<div odxLayout="flex" class="flex-column">
  <h5 i18n="@@floorplan.details.customPartNumbers.title" class="odx-title-5">Produkte</h5>
  <form odxForm [formGroup]="placeholderProductsForm" [readonly]="floorplanItem().locked" odxLayout="flex" class="flex-column">
    <div formArrayName="placeholderProducts">
      @for (_ of getProductsControls(); track index; let index = $index) {
        <div [formGroupName]="index">
          <odx-form-field
            i18n-label="@@floorplan.details.form.placeholderProduct.name.label"
            label="Name (optional)"
            [readonly]="floorplanItem().locked"
          >
            <input
              formControlName="name"
              odxFormFieldControl
              i18n-placeholder="@@floorplan.details.form.placeholderProduct.name.placeholder"
              placeholder="Name"
            />
          </odx-form-field>
          <odx-form-field
            i18n-label="@@floorplan.details.form.placeholderProduct.id.label"
            label="Sachnummer (optional)"
            [readonly]="floorplanItem().locked"
          >
            <input
              formControlName="id"
              odxFormFieldControl
              i18n-placeholder="@@floorplan.details.form.placeholderProduct.id.placeholder"
              placeholder="Sachnummer"
            />
          </odx-form-field>
          @if ((scope$ | async) === BusinessScope.FGDS) {
            <odx-form-field
              i18n-label="@@floorplan.details.form.placeholderProduct.price.label"
              label="Preis (optional)"
              [readonly]="floorplanItem().locked"
            >
              <input
                type="text"
                [value]="formatPriceValue(getProductsControls()[index].get('price')?.value)"
                (blur)="processPriceValue($event, getProductsControls()[index])"
                odxFormFieldControl
                i18n-placeholder="@@floorplan.details.form.placeholderProduct.price.placeholder"
                placeholder="Preis"
              />
            </odx-form-field>
          }
        </div>
      }
    </div>

    @if (showWarning) {
      <odx-inline-message variant="warning" i18n="@@floorplan.details.warning.placeholderProductsAvailable"
        >Alle Sachnummern dieses Platzhalters sind in den Produktdaten vorhanden. Es wird empfohlen, das Produkt direkt zu
        konfigurieren.</odx-inline-message
      >
    }

    @if (!hideAddButton && (isReadOnlyUser$ | async) === false) {
      <div>
        <a
          [disabled]="(hasWritePermission$ | async) === false || floorplanItem().locked"
          odxLink
          href="#"
          i18n="floorplan.details.form.placeholderProduct.btnAdd"
          (click)="addFormGroup(); $event.preventDefault()"
        >
          <odx-icon name="plus" size="medium"></odx-icon>
          Produkt hinzufügen
        </a>
      </div>
    }
  </form>
</div>
